import type { SystemInfo, SystemModule } from "../types/api.js";
import { apiRequest } from "./api-client.js";

/** Público: no requiere Bearer. */
export async function fetchSystemInfo(): Promise<SystemInfo> {
  return apiRequest<SystemInfo>("/api/v1/system/info", { method: "GET" });
}

/** Catálogo global y flags de plataforma (público). */
export async function fetchSystemModules(): Promise<{ modules: SystemModule[] }> {
  return apiRequest<{ modules: SystemModule[] }>("/api/v1/system/modules", { method: "GET" });
}
